import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconAddToList from '@/icons/AddToList.svg';
import { ActionTypeFromGetMany } from '@/models/actionType';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import { formatCurrency } from '@/utils/number';
import useViewPort from '@/utils/useViewport';

import ActionName from './ActionName';
import { RefusedByClientBadge } from './RefusedByClientBadge';

export const ActionDropdownItem = ({
  action,
  refusedByClient,
}: {
  action: ActionTypeFromGetMany;
  refusedByClient: boolean;
}) => {
  const { isMobile } = useViewPort();

  const { view: requestView } = useRequestContext();
  const { iam } = useArticleContext();

  const showWorkshopPrice = requestView.workshopPrice.shown;
  const showOrganizationPrice = requestView.organizationPrice.shown;

  const showWorkshopAmountBeforeTaxes = requestView.workshopPrice.showAmountBeforeTaxes;
  const showOrganizationAmountBeforeTaxes = requestView.organizationPrice.showAmountBeforeTaxes;

  return (
    <Stack
      row
      alignItems="center"
      justifyContent="space-between"
      gap="0.5rem"
      flexWrap="nowrap"
      style={{ flex: 1 }}
    >
      <Stack row alignItems="center" gap="0.5rem" flexWrap="nowrap">
        <ActionName
          actionType={action}
          refashionStatus={
            !!action.refashionBonus && !iam.hasOnlyWorkshopScopeOnArticle ? 'applied' : undefined
          }
        />
        {refusedByClient && <RefusedByClientBadge />}
      </Stack>
      <Stack
        {...(isMobile
          ? { alignItems: 'flex-end' }
          : { row: true, alignItems: 'center', gap: '0.5rem', flexWrap: 'nowrap' })}
      >
        {showWorkshopPrice && (
          <Paragraph weight="medium">
            {formatCurrency(
              showWorkshopAmountBeforeTaxes
                ? action.dynamicCost?.amountBeforeTaxes
                : action.dynamicCost?.amount,
              action.dynamicCost?.currency
            )}
          </Paragraph>
        )}
        {showOrganizationPrice && (
          <Paragraph weight="medium">
            {formatCurrency(
              showOrganizationAmountBeforeTaxes
                ? action.dynamicPrice?.amountBeforeTaxes
                : action.dynamicPrice?.amount,
              action.dynamicPrice?.currency
            )}
          </Paragraph>
        )}
      </Stack>
    </Stack>
  );
};

export const CustomActionDropdownItem = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <Stack row gap="0.5rem" alignItems="center" style={{ flex: 1, ...style }}>
      <IconAddToList style={{ fontSize: '1.25rem' }} />
      <Paragraph>
        <Trans id="article.form.actions.add-custom-action">Add a custom action</Trans>
      </Paragraph>
    </Stack>
  );
};
